<template>
  <transition name="slide-fade">
    <div
      class="searchHistroy"
      v-if="boxData.judgeBox && recommendTag.length"
      :style="{
      'top': boxData.fix.y+'px',
      'left': boxData.fix.x+'px',
      'z-index': boxData.Zindex, }"
      @mousedown="stopDocument($event)"
    >
      <div
        class="searchHistroy_body"
        style="
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        padding: 0 12px;
      "
      >
        <div class="itemTit" style="
          margin: 0px;
        ">热门搜索</div>

        <div
          class="item"
          v-for="item in recommendTag"
          @click="searchFs({value : item.name}, '热门推荐词')"
          style="
          width: auto;
          margin: 5px 5px 5px 0;
          height: 20px;
          padding: 5px 5px 5px 0;
        "
        >{{item.name}}</div>
      </div>

      <div class="searchHistroy_body">
        <div class="itemTit" style>搜索历史</div>

        <div class="item" v-for="item in searchData" @click="searchFs(item, '历史词')">{{item.value}}</div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      boxData: {
        judgeBox: false, // 控制盒子开启关闭
        Zindex: 0, // 盒子层级
        data: null, // 盒子数据
        fix: {
          // 弹窗位置
          x: 0,
          y: 0
        }
      },
      searchData: [],
      recommendTag: []
    };
  },
  watch: {
    "boxDatas.firstDatas": function(val, oldval) {
      // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.firstDatas, "searchHistroy");
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox) {
        // 打开的操作
        for (let i = 0; i < this.boxDatas.firstDatas.length; i++) {
          if (this.boxDatas.firstDatas[i] !== "searchHistroy") {
            this.$bus.emit("FeaturesPop_close_vue", {
              name: this.boxDatas.firstDatas[i],
              type: 1
            });
          }
        }
        let worksJson = this.$util.localStorage.get("SEARCH_history_record");
        this.boxData.data = this.dataMsg.searchHistroy;
        this.recommendTag = this.boxData.data.recommendTag;
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
        this.boxData.fix.x = this.boxData.data.posx + 30;
        this.boxData.fix.y = this.boxData.data.posy + 55;
        this.searchData = worksJson;
      }
    }
  },
  props: ["dataMsg", "boxDatas"],
  computed: {
    ...mapGetters([
      "TOOL",
      "SelectScenes_Msg",
      "TopNav_Size",
      "MaterialPane_Size",
      "S_GlobalSearch",
      "isClipboardEmpty"
    ])
  },
  mounted() {},
  methods: {
    stopDocument(e) {
      // 防止事件冒泡
      e.stopPropagation();
    },
    searchFs(data, keyword_type) {
      this.$store.commit('tracking/setTrackingData', {
        keyword_type,
      });
      let historyData = {
        value: data.value,
        type: "history"
      };
      this.$bus.emit("search-OpenClose", historyData);
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "searchHistroy",
        type: 1
      });
    }
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.searchHistroy {
  position: fixed;
  top: 0;
  left: 0;
  width: 250px;
  height: auto;
  z-index: 35;
  border-radius: 6px 6px 3px 3px;
  box-shadow: 0px 0px 4px 0px rgba(57, 77, 187, 0.2);
  border-radius: 8px;
  border: 1px solid #d8dee9;
  background: #fff;
  overflow: hidden;
  text-align: left;

  .dragArea {
    background: #d8dee9;
  }

  .searchHistroy_body {
    background: #fff;

    .itemTit {
      width: 220px;
      height: 45px;
      line-height: 15px;
      padding: 15px 0;
      margin: 0 15px;
      border-radius: 3px;
      border-bottom: 1px solid #f0f0f8;
      color: #474261;
      background: #fff;
      transition: all 0.3s;
    }

    .item {
      width: 220px;
      height: 15px;
      color: #474261;
      margin: 15px 15px;
      background: #fff;
      transition: all 0.3s;
      line-height: 15px;
      border-radius: 3px;
      cursor: pointer;

      &:hover {
        background: #e8e8e8;
      }
    }
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  height: 0px;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/searchHistroy.vue